import { Children } from 'react'

import styled, { css } from 'styled-components'

import { responsiveQuery } from 'styles'

type Props = {
	/** The width of each column, eg `[1, 2]` in fr. Defaults to `1fr` per column */
	columns?: Array<number>
	/** The gap between each column. Defaults to `12` */
	gap?: number
}

/**
 * Allows quick layouts of columns, typically for increasing the density of
 * input fields in forms.
 *
 * When in slim-mode (less than 240px adjusted for font-size), only a single
 * column is used.
 *
 * @example
 * ```tsx
 * <GridRow columns={[1, 2]}>
 *  <Input {...} />
 *  <Input {...} />
 * </GridRow>
 * ```
 */
export const GridRow = styled.div<Props>`
	display: grid;
	column-gap: ${({ gap = 12 }) => gap}px;
	grid-template-columns: ${({ columns, children }) =>
		columns ? columns.map((width) => `${width}fr`).join(' ') : `repeat(${Children.count(children)}, 1fr)`};
	align-items: end;

	${responsiveQuery.mobile(css`
		display: block;
	`)}
`
